/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import jsonConfig from './config.json'
const config = jsonConfig;

const awsmobile = {
    "aws_project_region": config.REACT_APP_REGION,
    "aws_cognito_identity_pool_id": config.REACT_APP_IDENTITYPOOL_ID,
    "aws_cognito_region": config.REACT_APP_REGION,
    "aws_user_pools_id": config.REACT_APP_USERPOOL_ID,
    "aws_user_pools_web_client_id": config.REACT_APP_WEBCLIENT_ID
};
export default awsmobile;